export const fastDialogSettings = {
    autoClose: 4000
}
